import { get, put, post, del } from "../api_helper";
import { BASE_URL } from "helpers/url_helper";

const BASE_API_URL = `${BASE_URL}/TestListDepartmentSite`;

const GetDataDepartmentSites = data => {
  return post(`${BASE_API_URL}/GetTestListDepartmentSites`, data);
};
const ExportTestListDepartmentSites = data => {
  return post(`${BASE_API_URL}/ExportTestListDepartmentSites`, data, {
    responseType: "blob",
  });
};

export { GetDataDepartmentSites, ExportTestListDepartmentSites };
